import * as React from "react";
import {useState} from "react";
import './forgotPassword.css'
import history from "../../../config/history";
import {PublicRoutes} from "../../../config/routes";
import Input from "../../../components/common/Input/Input";
import InputUtils, {Type} from "../../../InputUtils";
import {forgotPassword} from "../../../actions/boCoreActions";
import Utils from "../../../Utils";


export default function ForgotPassword(props: any) {
    const [form, setForm] = useState(JSON.parse(JSON.stringify(defaultForm)))

    const sentEmail = () => {
        if (checkFormValidity()) {
            const email = form.email.value
            forgotPassword({email: email})
                .then(() => {
                    Utils.$.confirm({
                        title: 'Email sent successfully',
                        keyboardEnabled: true,
                        escapeKey: 'cancel',
                        backgroundDismiss: false,
                        content: 'Please check your email and click on the provided link to reset your password.',
                        type: 'green',
                        theme: 'dark',
                        typeAnimated: false,
                        buttons: {
                            ok: {
                                text: "Ok!",
                                btnClass: 'btn-primary',
                                keys: ['enter'],
                                action: () => {
                                    backToLogin();
                                }
                            },
                        }
                    });
                })
        }
    };

    const onEnter = (e) => {
        if (e.which === 13) {
            sentEmail();
        }
    };

    const checkFormValidity = (): boolean => {
        const formCopy = JSON.parse(JSON.stringify(form));
        let formIsValid = true;
        const str = formCopy.email.value;

        if (!InputUtils.EMAIL_REGEX.test(str)) {
            formCopy.email.valid = false;
            formIsValid = false;
        }

        setForm(formCopy)
        return formIsValid;
    }

    const backToLogin = () => {
        history.push(`${process.env.ENV_PREFIX}${PublicRoutes.LOGIN}`)
    }

    const onChange = (event, id) => {
        const eventValue = event.target.value;

        setForm({
            ...form,
            [id]: {
                ...form[id],
                value: eventValue,
                valid: true
            }
        });
    }

    return (
        <div onKeyDown={onEnter} id='login-wrapper' className={'background-gradient'} style={{height: '100vh'}}>
            <div className={'app-wrapper-image login-background'}/>
            <div className="middle-box text-center loginscreen animated fadeInDown">
                <div className={'login-container'}>
                    <h1 style={{fontSize: 30, color: '#adadad', marginTop: 0}}>Forgot Password</h1>
                    <div className="form-group">
                        <Input id={'email'}
                               value={form.email.value}
                               required={true}
                               elementType={Type.INPUT}
                               changed={(event) => onChange(event, 'email')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               valid={form.email.valid}
                               errorMsg={form.email.errorMsg}
                               elementConfig={{
                                   placeholder: 'Email',
                                   tabIndex: 1
                               }}
                        />
                    </div>
                    <button onClick={sentEmail} style={{width: "100%"}} className="btn new-style-btn">Reset my Password</button>
                    <div className={'register-forgotPass-container'}>
                        <p onClick={backToLogin}><i className="fas fa-arrow-left"/> Back</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

const defaultForm = {
    email: {
        value: '',
        valid: true,
        errorMsg: 'Invalid email address',
    }
}



// WEBPACK FOOTER //
// ./app/views/bo-core/forgotPassword/ForgotPassword.tsx